import styles from "./home-granular.style.module.scss";
import productImg from "./product.webp";
static const product = {
  name: "iPhone 16 Pro",
  price: "999",
  image: productImg,
  description:
    "Vibrant Joy-Con colors, in pristine condition! Stunning display and smooth gameplay, perfect for Super Mario Party Jamboree and more.",
  review: {
    title: "Awesome Phone, Awesome Photos!",
    description:
      "Just upgraded to the iPhone 16 Pro from my old iPhone 12, and it's like a whole new world! The Desert Titanium color looks super cool.",
  },
};

let/progress=0
script --
  const id = setTimeout(() => (progress = (progress + 0.01) % 1.5), 20);
  $signal.onabort = () => clearTimeout(id);

section class=styles.section
  div class=styles.content
    h2
      span class=styles.headingText -- Granular by Design
    p
      -- Why ship entire${" "}
      a href="https://www.patterns.dev/vanilla/islands-architecture/" -- Islands
      --
      ${" "}for a few grains of sand? Marko ships only what's needed, skipping hydration
      and stripping unused code at the sub-template level.
      --
    p --
      Lean by default. Fast by design. Unrivaled performance on any device or
      network.
    home-cta-button href="/docs/explanation/fine-grained-bundling" -- Learn How

  figure class=styles.demo
    demo-page
      ,label="a visual representation showing every component on a webpage re-executing in the browser with JavaScript"
      ,title="full-page"
      ,product=product
      ,progress=1
      ,hydrateAll
    demo-page
      ,label="a visual representation showing only interactive parts of a webpage resuming with JavaScript"
      ,title="granular"
      ,product=product
      ,progress=1
      ,hydratePartial
